import {
  FETCH_SHOP_THE_LOOK_SUCCESS,
  FETCH_SHOP_THE_LOOK_FAILURE,
  FETCH_SHOP_THE_LOOK_REQUEST,
  UPDATE_SHOP_THE_LOOK
} from '../../actionTypes/shopTheLookActionTypes'

const fetchShopTheLookSuccess = payload => {
  const action = {
    type: FETCH_SHOP_THE_LOOK_SUCCESS,
    payload
  }
  return action
}

const fetchShopTheLookFailure = ({ errorDetail, partNumber }) => {
  const action = {
    type: FETCH_SHOP_THE_LOOK_FAILURE,
    payload: { errorDetail: errorDetail.toString(), partNumber }
  }
  return action
}

const fetchShopTheLookRequest = payload => {
  const { partNumber, type, productImage } = payload
  const action = {
    type: FETCH_SHOP_THE_LOOK_REQUEST,
    payload: {
      type,
      partNumber,
      productImage
    }
  }
  return action
}

const updateShopTheLook = payload => {
  const action = {
    type: UPDATE_SHOP_THE_LOOK,
    payload
  }
  return action
}

export { fetchShopTheLookFailure, fetchShopTheLookSuccess, fetchShopTheLookRequest, updateShopTheLook }
